var map = {
	"./commercial/store.js": "ffd9",
	"./feed/store.js": "952a",
	"./lead/store.js": "5e79",
	"./product/store.js": "edea",
	"./reports/store.js": "e2ae",
	"./representative/store.js": "4be6",
	"./reseller/store.js": "25d9",
	"./settings/store.js": "dd3c",
	"./user/store.js": "1053"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fcda";